import { useEffect, useLayoutEffect, useState } from "react";
import { applyTheme, readTheme, THEME_KEY } from "../utils/theme";

export default function ThemeToggle() {
  const [theme, setTheme] = useState(readTheme);
  const light = theme === "light";

  useLayoutEffect(() => {
    applyTheme(theme);
    try { localStorage.setItem(THEME_KEY, theme); } catch { /* The toggle still works without storage. */ }
  }, [theme]);

  useEffect(() => {
    const syncTheme = event => {
      if (event.key === THEME_KEY || event.key === null) setTheme(readTheme());
    };
    window.addEventListener("storage", syncTheme);
    return () => window.removeEventListener("storage", syncTheme);
  }, []);

  return (
    <button type="button" className="theme-toggle fixed right-4 top-4 sm:right-6 sm:top-6 z-50 flex h-10 items-center gap-2 rounded-2xl border px-3 text-xs sm:text-sm font-semibold shadow-sm"
      aria-label={`Switch to ${light ? "dark" : "light"} mode`}
      onClick={() => setTheme(light ? "dark" : "light")}>
      <svg aria-hidden="true" viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        {light ? <path d="M20.8 13A9 9 0 0 1 11 3.2 9 9 0 1 0 20.8 13Z" /> : <>
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5" />
        </>}
      </svg>
      {light ? "Dark mode" : "Light mode"}
    </button>
  );
}
